
import { fetchTagList } from '@/api/tag/list';
import { deleteTag } from '@/api/tag/delete';
import deleteBtn from '@/components/DeleteBtn';
import CreateTagPopover from './createTagPopover.vue';

export default {
  components: {
    deleteBtn: deleteBtn,
    CreateTagPopover: CreateTagPopover
  },

  data: function data() {
    return {
      list: [],
      listLoading: false,
      page: 1,
      page_size: 15,
      secondSelectedType: 'all',
      picOptions: [{
        value: 'all',
        label: '全部'
      }, {
        value: '6',
        label: '2D特效'
      }, {
        value: '8',
        label: '2D动画'
      }],
      videoOptions: [{
        value: 'all',
        label: '全部'
      }, {
        value: '9',
        label: '视频标签'
      }, {
        value: '10',
        label: '视频分类'
      }],
      audioOptions: [{
        value: 'all',
        label: '全部'
      }, {
        value: '11',
        label: 'BGM'
      }, {
        value: '12',
        label: '音效'
      }],
      total: 1,

      dialogConfig: {
        visible: false,
        title: '新增标签'
      }
    };
  },

  props: {
    type: {
      type: String,
      default: '1'
    }
  },
  computed: {
    secondOptionTab: function secondOptionTab() {
      return Number(this.type) === 6 || Number(this.type) === 7 || Number(this.type) === 8;
    }
  },
  methods: {
    renderList: function renderList() {
      var _this = this;

      var oTemp = {};
      oTemp.page = this.page;

      switch (true) {
        // 选中2级菜单全部展示
        case this.secondOptionTab && this.secondSelectedType === 'all':
          oTemp.type_ids = this.getTypeStringList();
          break;
        // 选中二级菜单一项
        case this.secondOptionTab:
          oTemp.type_ids = this.secondSelectedType;
          break;
        // 无二级菜单
        default:
          oTemp.type_ids = this.type;
          break;
      }
      this.listLoading = true;
      fetchTagList(oTemp).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.data.list;
        _this.total = res.data.data.total;
      });
    },
    secondeSelect: function secondeSelect() {
      this.page = 1;
      this.renderList();
    },
    getTypeStringList: function getTypeStringList() {
      var list = void 0;
      var type = '';
      switch (true) {
        case Number(this.type) === 6:
          list = this.picOptions;
          break;
        case Number(this.type) === 7:
          list = this.videoOptions;
          break;
        case Number(this.type) === 8:
          list = this.audioOptions;
          break;
        default:
          break;
      }
      for (var i in list) {
        if (i > 0) type = type + list[i].value; // 第一项为默认值，过滤掉
        if (i > 0 && i < list.length - 1) type = type + ',';
      }
      return type;
    },
    handleDelete: function handleDelete(obj) {
      var _this2 = this;

      this.listLoading = true;
      deleteTag({
        id: obj.id
      }).then(function (res) {
        _this2.$message({
          message: '删除成功',
          type: 'success'
        });
        _this2.page = 1;
        _this2.renderList();
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.renderList();
    }
  },
  mounted: function mounted() {
    this.renderList();
  }
};